import axios from "axios";
import Modal from "./UI/Modal";
import Form from "./Form/Form";
import Input from "./Form/Input";
import Checkbox from "./Form/Checkbox";
import { APIURL } from "..";
import { useToast } from "./UI/useToast";
import { useEffect, useState } from "react";
import Loading from "./UI/Loading";
import GDPR from "../assets/documents/PV0 - GDPR - Podmínky ochrany osobních údajů.pdf";

const FormModal = ({ state }) => {
    const { addToast } = useToast();
    let [modaltype, set] = state;
    const [formData, setFormData] = useState({});

    const handleSubmit = (data) => {
        var dataPrep = formData?.inputs.map((d, i) => ({
            id: d.id,
            value: data[d.name],
        }));
        var dataFinal = {
            name: modaltype,
            data: dataPrep,
            language: 'cs'
        };

        const message = modaltype === "petice"?"Děkujeme za váš zájem, detailní informace vám budou zaslány na e-mail, až bude petice spuštěná." : modaltype === "simulace"? "Děkujeme za váš zájem, odkaz ke stažení vám bude zaslán na e-mail.":"Děkujeme za váš zájem."; 
        axios
            .post(APIURL + "/newAnswer", dataFinal)
            .then((response) => {
                addToast({ type: "success", message });
            })
            .catch((err) => {
                addToast({
                    type: "error",
                    message:
                        "Nastala se chyba, kontaktujte nás prosím na admin@agenturagen.cz.",
                });
            });
        set(false);
    };

    const getForm = async () => {
        await axios
            .post(APIURL + "/form", { name: modaltype, language: 'cs' })
            .then((response) => {
                setFormData(response.data.body);
            });
    };

    useEffect(() => {
        modaltype ? getForm() : setFormData(null)
    }, [modaltype]);

    if (modaltype&&formData) return (
        <Modal state={state}>
            <div className="formModal form">
                {formData ? (
                    <>
                        <div className="perex frm">
                            <h2>
                                <mark>{formData?.display_name}</mark>
                            </h2>
                            {modaltype === "simulace"&&<p>E-mail vyžadujeme kvůli následným aktualizacím, o kterých Vás budeme moci rovnou informovat.</p>}
                        </div>
                        <Form onSubmit={handleSubmit}>
                            {formData?.inputs?.map((input, index) => {
                                if (
                                    input.type == "input" ||
                                    input.type == "textarea"
                                ) {
                                    return (
                                        <>
                                            <Input
                                                id={input.id}
                                                label={input.label}
                                                name={input.name}
                                                placeholder={input.placeholder}
                                                className={
                                                    (input.type == "input" && input.name != "firm" && modaltype=== "services") &&
                                                    "half"
                                                }
                                                required={
                                                    input.required
                                                        ? true
                                                        : false
                                                }
                                                type={input.input_type}
                                            />
                                        </>
                                    );
                                }
                            })}
                            <Checkbox name="GDPR_form" required>
                                Souhlasím s{" "}
                                <a href={GDPR} target="_blank">
                                    GDPR
                                </a>
                            </Checkbox>
                            <button type="submit" className="blue">
                                {"Odeslat"}
                            </button>
                        </Form>
                    </>
                ) : (
                    <Loading />
                )}
            </div>
        </Modal>
    );
};

export default FormModal;
